<div class="card-base">
    <div class="card-content-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{filt.toolTip}}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-orientation-filter #filters></app-orientation-filter>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <p-scrollPanel *ngIf="!loading" styleClass="scroll-panel">
                    <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="name">
                            <th class="search-table-header" mat-header-cell *matHeaderCellDef> Nombre </th>
                            <td (click)="startCaller(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                {{element.Name}}
                            </td>
                        </ng-container>

                        <!-- Star Column -->
                        <ng-container matColumnDef="star" stickyEnd>
                            <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <button mat-icon-button [matMenuTriggerFor]="menuItem">
            <mat-icon>more_vert</mat-icon>
          </button>
                                <mat-menu #menuItem="matMenu">
                                    <button mat-menu-item (click)="startCaller(element)">
              <mat-icon>flag</mat-icon><span>Iniciar</span>
            </button>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </p-scrollPanel>
                <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>